import React from 'react';
import { useDispatch } from 'react-redux';
import * as ProjectActions from 'store/project/projectSlice';
import ChecklistItem from './ChecklistItem';

export default function Checklist({checklist}) {
  const dispatch = useDispatch();

  const onHandleChange = (values) => {
    dispatch(ProjectActions.setChecklistOptions(values));
    dispatch(ProjectActions.setChecklistOptionsChecked());
    dispatch(ProjectActions.setChecklistOptionsDisabled());
  };

  return (
    <div className="app-checklist">
      {checklist.filter(checklistItem => !checklistItem.isHidden).map((checklistItem) => (
        <ChecklistItem
          key={checklistItem.id}
          checklistItem={checklistItem}
          onChange={onHandleChange}
        />
      ))}
    </div>
  )
}
